import CreateClient from './createClient';
import events from '../utils/events';

export default ({ config }) => {
  let token = '';

  const client = new CreateClient({
    config,
    getToken: () => token,
    setToken: (newToken) => {
      events.emit('setToken', newToken);
    },
    logout: () => {
      events.emit('logout');
    },
  });

  const api = {
    setToken: (t) => {
      token = t;
    },
    auth: {
      login({ username, password }) {
        return client.request({
          method: 'post',
          url: '/auth/login/',
          data: {
            username,
            password,
          },
        });
      },
      forgotPassword(email) {
        return client.request({
          method: 'post',
          url: '/auth/forgot_password/',
          data: {
            email,
          },
        });
      },
      resetPassword({
        uid,
        token: resetToken,
        newPassword,
        confirmNewPassword,
      }) {
        return client.request({
          method: 'post',
          url: '/auth/reset_password/',
          data: {
            uid,
            token: resetToken,
            new_password1: newPassword,
            new_password2: confirmNewPassword,
          },
        });
      },
      changePassword({ oldPassword, newPassword, confirmNewPassword }) {
        return client.request({
          method: 'post',
          url: '/auth/change_password/',
          data: {
            old_password: oldPassword,
            new_password1: newPassword,
            new_password2: confirmNewPassword,
          },
        });
      },
      refreshToken(refreshToken) {
        return client.request({
          method: 'post',
          url: '/auth/refresh_token/',
          data: {
            token: refreshToken,
          },
        });
      },
      me() {
        return client.request({
          method: 'get',
          url: '/auth/me/',
        });
      },
    },
    users: {
      get({ id, params } = {}) {
        let url = '/users/';

        if (id) {
          url += `${id}/`;
        }
        return client.request({
          method: 'get',
          url,
          params,
        });
      },
      create({
        firstName,
        lastName,
        email,
        role,
        optionalEmail1,
        optionalEmail2,
        optionalEmail3,
        optionalEmail4,
        optionalEmail5,
      }) {
        return client.request({
          method: 'post',
          url: '/users/',
          data: {
            first_name: firstName,
            last_name: lastName,
            email,
            role,
            optional_email_one: optionalEmail1,
            optional_email_two: optionalEmail2,
            optional_email_three: optionalEmail3,
            optional_email_four: optionalEmail4,
            optional_email_five: optionalEmail5,
          },
        });
      },
      update(
        id,
        {
          firstName,
          lastName,
          email,
          role,
          optionalEmail1,
          optionalEmail2,
          optionalEmail3,
          optionalEmail4,
          optionalEmail5,
        },
      ) {
        return client.request({
          method: 'patch',
          url: `/users/${id}/`,
          data: {
            first_name: firstName,
            last_name: lastName,
            email,
            role,
            optional_email_one: optionalEmail1,
            optional_email_two: optionalEmail2,
            optional_email_three: optionalEmail3,
            optional_email_four: optionalEmail4,
            optional_email_five: optionalEmail5,
          },
        });
      },
      updateStatus(id, status) {
        return client.request({
          method: 'patch',
          url: `/users/${id}/`,
          data: {
            is_active: status,
          },
        });
      },
      requestResetPassword(id) {
        return client.request({
          method: 'post',
          url: `/users/${id}/reset/`,
        });
      },
    },
    reports: {
      get({ id, params } = {}) {
        let url = '/documents/';

        if (id) {
          url += `${id}/`;
        }

        return client.request({
          method: 'get',
          url,
          params,
        });
      },
      updateStatus(id, status) {
        return client.request({
          method: 'patch',
          url: `/documents/${id}/`,
          data: {
            status,
          },
        });
      },
      create({
        title,
        type,
        document,
        assignTo,
      }) {
        return client.request({
          method: 'post',
          url: '/documents/',
          data: {
            title,
            document_type: type,
            document,
            assigned_to: { id: assignTo },
          },
        });
      },
      async download(id) {
        const response = await client.request({
          method: 'post',
          url: `/documents/${id}/generate_download/`,
        });

        return {
          url: `${config.api.baseURL}/documents/download/?token=${
            response.token
          }`,
          filename: response.filename,
        };
      },
    },
    stats: {
      get() {
        return client.request({
          method: 'get',
          url: '/stats/all/',
        });
      },
    },
    audits: {
      get({ params }) {
        return client.request({
          method: 'get',
          url: '/audits/',
          params,
        });
      },
    },
  };
  return api;
};



// WEBPACK FOOTER //
// ./src/services/api.js